import {
  getDefaultBuiltinToolAllowlistForAgent,
  ToolNames,
} from '@kanbu/schema/contracts';
import { Agent } from '@kanbu/schema/enums';
import { useFieldState, useFormApi } from 'informed';
import { useEffect, useRef } from 'react';

export function useBuiltinToolAllowlistSync() {
  const agentFieldState = useFieldState('agent');
  const formApi = useFormApi();
  const previousAgentRef = useRef<Agent | undefined>(undefined);
  const allowlistInitializedRef = useRef(false);

  const selectedAgent = agentFieldState.value as Agent | undefined;
  const supportsBuiltinToolSelection =
    selectedAgent === Agent.Conversational ||
    selectedAgent === Agent.ShopAssistant;

  useEffect(() => {
    if (!supportsBuiltinToolSelection || selectedAgent === undefined) {
      return;
    }

    const defaults = getDefaultBuiltinToolAllowlistForAgent(selectedAgent);
    const raw = formApi.getValue('agentConfig.enabledBuiltinTools') as
      | string[]
      | undefined;
    const previous = previousAgentRef.current;
    const agentChanged = previous !== undefined && previous !== selectedAgent;

    previousAgentRef.current = selectedAgent;

    if (agentChanged) {
      formApi.setValue('agentConfig.enabledBuiltinTools', defaults);
      allowlistInitializedRef.current = true;

      return;
    }

    if (!allowlistInitializedRef.current && !Array.isArray(raw)) {
      formApi.setValue('agentConfig.enabledBuiltinTools', defaults);
      allowlistInitializedRef.current = true;
    }
  }, [supportsBuiltinToolSelection, selectedAgent, formApi]);

  useEffect(() => {
    const raw = formApi.getValue('agentConfig.enabledBuiltinTools') as
      | string[]
      | undefined;

    if (!Array.isArray(raw) || !raw.includes(ToolNames.WebSearch)) {
      return;
    }

    formApi.setValue(
      'agentConfig.enabledBuiltinTools',
      raw.filter(name => name !== ToolNames.WebSearch),
    );
  }, [formApi, selectedAgent]);
}
